import Provider from './Provider';
import Installation from './Installation';
import Installed from './Installed';
import PublicLink from './PublicLink';
import AI from './AI';
import Extensions from './Extensions';
import withManifest from './manifest/withManifest';
var useInstallationSetting = Installation.useInstallationSetting,
    InstallationProvider = Installation.InstallationProvider;
var usePublicLink = PublicLink.usePublicLink,
    PublicLinkProvider = PublicLink.PublicLinkProvider;
export default {
  Provider: Provider,
  usePublicLink: usePublicLink,
  PublicLinkProvider: PublicLinkProvider,
  useInstallationSetting: useInstallationSetting,
  InstallationProvider: InstallationProvider,
  Installed: Installed,
  Extensions: Extensions,
  AI: AI,
  withManifest: withManifest
};